import { ZDService } from "~/entity/ZD/api/service";

export const useZD = () => {
  const queryKeys = {};

  const getZDPositionsList = ZDService.GET.getZDPositionsList;

  const setCompliance = ZDService.POST.setCompliance;
  const startCheck = ZDService.POST.startCheck;

  const updateComment = ZDService.PUT.updateComment;
  const updateFiles = ZDService.PUT.updateFiles;

  return {
    queryKeys,
    // GET
    getZDLists: {
      personal: getZDPositionsList,
    },

    // POST
    setCompliance,
    startCheck,

    // PUT
    updateComment,
    updateFiles,
  };
};
